'use strict';
var ansiRegex = require('ansi-regex')();

module.exports = function (str) {
	return typeof str === 'string' ? str.replace(ansiRegex, '') : str;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/postcss/node_modules/strip-ansi/index.js
// module id = 956
// module chunks = 0